import { InsuranceType } from './insurance-type.enum';

export enum ProposalState {
  PROPOSAL_SAVED = 'PROPOSAL_SAVED',
  OFFER_CREATED = 'OFFER_CREATED',
  SIGNED_DOCS = 'SIGNED_DOCS',
  OFFER_ACCEPTED = 'OFFER_ACCEPTED',
  REJECTED = 'REJECTED',
  POLICY_CREATED = 'POLICY_CREATED',
  WAITING_PAIEMENT = 'WAITING_PAIEMENT',
}

export const getProposalStateLabel = (status: ProposalState): string => {
  switch (status) {
    case ProposalState.PROPOSAL_SAVED:
      return $localize`Enregistrée`;
    case ProposalState.OFFER_ACCEPTED:
      return $localize`Acceptée par client`;
    case ProposalState.SIGNED_DOCS:
      return $localize`En attente de validation`;
    case ProposalState.OFFER_CREATED:
      return $localize`En attente`;
    case ProposalState.REJECTED:
      return $localize`Rejetée`;
    case ProposalState.POLICY_CREATED:
      return $localize`Acceptée`;
    case ProposalState.WAITING_PAIEMENT:
      return $localize`En attente de paiement`;
    default:
      return status;
  }
};

export const getProposalStateBadgeClass = (status: ProposalState): string => {
  switch (status) {
    case ProposalState.PROPOSAL_SAVED:
      return $localize`zinc`;
    case ProposalState.SIGNED_DOCS:
      return $localize`zinc`;
    case ProposalState.OFFER_ACCEPTED:
      return $localize`success`;
    case ProposalState.OFFER_CREATED:
      return $localize`zinc`;
    case ProposalState.WAITING_PAIEMENT:
      return $localize`blue`;
    case ProposalState.REJECTED:
      return $localize`danger`;
    case ProposalState.POLICY_CREATED:
      return $localize`success`;
    default:
      return '';
  }
};

export enum Periodicity {
  MONTH = 'Month',
  YEAR = 'Year',
  QUARTER = 'Quarter',
  SEMESTER = 'Semester',
  UNIQUE = 'Unique',
}

export const getPeriodicityLabel = (periodicity: Periodicity): string => {
  switch (periodicity) {
    case Periodicity.MONTH:
      return $localize`Mensuel`;
    case Periodicity.YEAR:
      return $localize`Annuel`;
    case Periodicity.QUARTER:
      return $localize`Trimestriel`;
    case Periodicity.SEMESTER:
      return $localize`Semestriel`;
    case Periodicity.UNIQUE:
      return $localize`Prime unique`;
    default:
      return periodicity;
  }
};

export const getPeriodicityMultiplier = (periodicity: Periodicity): number => {
  switch (periodicity) {
    case Periodicity.MONTH:
      return 12;
    case Periodicity.YEAR:
      return 1;
    case Periodicity.QUARTER:
      return 4;
    case Periodicity.SEMESTER:
      return 2;
    case Periodicity.UNIQUE:
      return 1;
    default:
      return 1;
  }
};

export const getPeriodicityByInsuranceType = (
  insuranceType: InsuranceType
): Periodicity => {
  if (
    insuranceType === InsuranceType.HEALTH ||
    insuranceType === InsuranceType.COMPLEMENTARY_HEALTH
  )
    return Periodicity.MONTH;
  return Periodicity.YEAR;
};

export enum PolicyStatus {
  ACTIVE = 'ACTIVE',
  SUSPENDED = 'SUSPENDED',
  CANCELLED = 'CANCELLED',
  ARCHIVED = 'ARCHIVED',
  PENDING = 'PENDING',
  INACTIVE = 'INACTIVE',
}

export const getPolicyStatusLabel = (status: PolicyStatus | string): string => {
  switch (status) {
    case PolicyStatus.ACTIVE:
      return $localize`Active`;
    case PolicyStatus.SUSPENDED:
      return $localize`Suspendue`;
    case PolicyStatus.CANCELLED:
      return $localize`Résiliée`;
    case PolicyStatus.ARCHIVED:
      return $localize`Archivée`;
    case PolicyStatus.PENDING:
      return $localize`En attente`;
    case PolicyStatus.INACTIVE:
      return $localize`Hors mandat`;
    default:
      return status;
  }
};

export const getPolicyStatusClass = (status: PolicyStatus): string => {
  switch (status) {
    case PolicyStatus.ACTIVE:
      return 'success';
    case PolicyStatus.SUSPENDED:
      return 'danger';
    case PolicyStatus.CANCELLED:
      return '';
    case PolicyStatus.ARCHIVED:
    case PolicyStatus.PENDING:
      return 'zinc';
    default:
      return '';
  }
};

export enum PolicyOrigin {
  CENTRALISATION = 'CENTRALISATION',
  LEAD = 'LEAD',
  IMPORT = 'IMPORT',
}

export const getPolicyOriginLabel = (origin: PolicyOrigin | string): string => {
  switch (origin) {
    case PolicyOrigin.CENTRALISATION:
      return $localize`Centralisation`;
    case PolicyOrigin.LEAD:
      return $localize`Demande`;
    case PolicyOrigin.IMPORT:
      return $localize`Import`;
    default:
      return origin;
  }
};
